export class DCMemSRRelationship {
  //"Account Membership Id": string = "";
  "Relationship": string = "Contact";
  "Action Type": string = "Add";
  "DC Start Date": string = "";
  "DC End Date": string = "";
  "DC Member Relationship": string = "Contact";
  "DC Main Phone": string = "";
  "Member DOB": string = "";
  "DC Emirates ID Number": string = "";
  "DC National ID": string | null = null;
  "DC Ownership Percent": string = "";
  "DC Relationship Type": string = "Contact";
  "DC PP Exp Date": string = "";
  "UAE Citizen": string = "No";
  "DC Contact Name(ARABIC)": string = "";
  "DC Contact Name(ENGLISH)": string = "";
  "DC Name(ENGLISH)": string = "";
  "DC Name(ARABIC)": string = "";
  "DC Cell Phone": string = "";
  "Membership Year": string = "";
  "DC DED Partner Passport Number": string = "";
  "DC Contact Nationality": string = "";
  "DC Email Address": string = "";
  "DC DED PartnerNationalityCode": string = "";
  "DC Authorized Signatory": string = "";
  "DC Job Title": string = "";
}

export class ListOfDCMemSRRelationship {
  "DC Mem SR Relationship": DCMemSRRelationship[] = [];
}

export class DCMemSR {
  "DC Channel": string = "Online";
  "SR Sub Type": string = "";
  "DC Member Name(Arabic)": string = "";
  "DC Member Name(English)": string = "";
  "SR Type": string = "";
  //"ListOfDC Mem SR Relationship": ListOfDCMemSRRelationship = new ListOfDCMemSRRelationship();
  "ListOfDC Mem SR Relationship": ListOfDCMemSRRelationship | {} = new ListOfDCMemSRRelationship();
  // Optional
  "SR Number"?: string;
  "Status"?: string;
  "Account Id"?: string;
}

export class ListOfDCMemSRIO {
  "DC Mem SR": DCMemSR = new DCMemSR();
}

export class SiebelMessage {
  xmlns: string = "http://www.siebel.com/xml/DC%20Query%20Member%20Info";
  MessageId: string = ""; // should be set dynamically
  MessageType: string = "Integration Object";
  IntObjectName: string = "DCMemSRIO";
  IntObjectFormat: string = "Siebel Hierarchical";
  ListOfDCMemSRIO: ListOfDCMemSRIO = new ListOfDCMemSRIO();
}

export class AddSignatoryBody {
  ProcessName: string = "DC Create Update SR Web WF";
  SiebelMessage: SiebelMessage = new SiebelMessage();
  "DCMethod": string = "SAVEASDRAFT";
}

export class AddSignatoryRequest {
  body: AddSignatoryBody = new AddSignatoryBody();
}
